import moment from 'moment-timezone';
import qs from 'qs';
import {
  AFFILIATE_MAPPINGS_REQUEST,
  AFFILIATE_MAPPINGS_FAILURE,
  AFFILIATE_MAPPINGS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function affiliateMappingsRequest() {
  return {
    type: AFFILIATE_MAPPINGS_REQUEST,
  };
}

function affiliateMappingsSuccess(data, token = null) {
  return {
    type: AFFILIATE_MAPPINGS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function affiliateMappingsError(message) {
  return {
    type: AFFILIATE_MAPPINGS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchAffiliateMappings(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(affiliateMappingsRequest());
    if (!fresh) {
      let affiliateMappingsData = {};
      try {
        affiliateMappingsData = JSON.parse(getItem(`${config.get('appName')}.affiliateMappings`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !affiliateMappingsData.data ||
        config.get('version') !== affiliateMappingsData.version ||
        moment().isAfter(moment(affiliateMappingsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(affiliateMappingsSuccess(affiliateMappingsData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
    });
    return dispatch(fetchM(`/mappings/affiliates/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.affiliateMappings`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(affiliateMappingsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, affiliateMappingsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/affiliateMappings.js